import { create } from 'zustand';

interface ReconnectState {
  reconnecting: boolean;
  /** True while waiting indefinitely for a dropped HOST to come back (shows the
   *  "waiting for host" overlay + Quitter), vs a bounded boot reconnect. */
  waiting: boolean;
  setReconnecting: (v: boolean) => void;
  setWaiting: (v: boolean) => void;
}

export const useReconnectStore = create<ReconnectState>((set) => ({
  reconnecting: false,
  waiting: false,
  setReconnecting: (reconnecting) => set({ reconnecting }),
  setWaiting: (waiting) => set({ waiting }),
}));
